import { Dispatch } from "redux";
import * as actions from "../common/actions";
import { updateApp } from "../common/actions";
import App from "../App";
import { connect } from "react-redux";
import { All } from "../interfaces";

export function mapStateToProps({ appState }: All) {
  return {
    uuid: appState.uuid,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateApp: (app: string) => {
      dispatch(updateApp(app));
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
